<!-- <div class="grid h-screen">
  <landing-header style="min-height: 85px"></landing-header>
  <main class="flex-grow">
    <div class="min-h-screen bg-[var(--surface-100)]">
      <router-outlet></router-outlet>
    </div>
  </main>
  <landing-footer style="min-height: 472px"></landing-footer>
</div> -->
<router-outlet></router-outlet>

